export default "__VITE_ASSET__D$PaE_7B__"